export default "__VITE_ASSET__698219e3__"